module.exports = {"newsletter":{"title":"最新のJSランキングを毎週配信します。","text":"{link} ニュースレターに登録すると、いまもっとも熱い JavaScript プロジェクトをウィークリーでお届けします。","button":"登録","placeholder":"あなたのメールアドレス"},"view_project":{"twitter":{"text":"{year}年、{name}はGitHubで{delta}スターを獲得し、{category}カテゴリで{ranking}位になりました。","action":"Tweet"},"months":"1月 2月 3月 4月 5月 6月 7月 8月 9月 10月 11月 12月","created":"作成日","homepage":"WEB サイト"}}


//////////////////
// WEBPACK FOOTER
// ./i18n/common/ja.yaml
// module id = 453
// module chunks = 230186691558513